exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-panel-body {\n  overflow: hidden;\n  -webkit-transition-property: height;\n  /* Safari */\n  transition-property: height;\n  -webkit-transition-timing-function: ease-in-out;\n  /* Safari and Chrome */\n  transition-timing-function: ease-in-out;\n}\n.uu5-bricks-panel-body-block {\n  overflow: visible;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/panel-body.less
// module id = 247
// module chunks = 0